var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{on:{"change":function (ref) {
	var value = ref.target.value;

	return value === '' ? _vm.reset() : _vm.setItem(value);
}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }